import React from "react";
import { useNavigate } from "react-router-dom";
import PrimaryButton from "../shared/Button/PrimaryButton";

export default function Forbidden() {
    const navigate = useNavigate();
    return (
        <div className="card text-center m-5">
            <i className="pi pi-lock text-5xl mb-3" />
            <h2>Access denied</h2>
            <p>You do not have permission to access this feature.</p>
            <PrimaryButton label="Go back" onClick={() => navigate(-1)} />
        </div>
    );
}
